export const transformOrderFieldsToObject = (
	fields:
		| {
				orderFieldId: number;
				value?: string | number | boolean | null;
				key: string;
		  }[]
		| null
		| undefined,
) => {
	if (!fields) return {};

	return fields.reduce(
		(acc, item) => {
			acc[item.key] =
				typeof item.value === "boolean" ? String(item.value) : item.value;
			return acc;
		},
		{} as Record<string, string | number | null | undefined>,
	);
};
